module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.render) ? _c('div', {
    staticClass: "bigMenu"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cols s_24 l_8"
  }, [_c('ul', _vm._l((_vm.api_response.items), function(item, index) {
    return _c('li', {
      on: {
        "mouseenter": _vm.activeLevel1
      }
    }, [(_vm.versionMob) ? [(item.submenu) ? _c('div', {
      staticClass: "wrap",
      on: {
        "click": function($event) {
          _vm.blockLink($event, index), _vm.clickShowL2($event, index)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": item.href
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t"), _c('span', {
      staticClass: "nextLevel"
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M0-.25h24v24H0z",
        "fill": "none"
      }
    })])])])]) : _c('a', {
      attrs: {
        "href": item.href
      },
      on: {
        "click": function($event) {
          _vm.clickShowL2($event, index)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t")])] : [(item.submenu) ? _c('a', {
      attrs: {
        "href": item.href
      },
      on: {
        "mouseenter": function($event) {
          _vm.hoverLevel1($event, index)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t"), _c('span', {
      staticClass: "nextLevel"
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M0-.25h24v24H0z",
        "fill": "none"
      }
    })])])]) : _c('a', {
      attrs: {
        "href": item.href
      },
      on: {
        "mouseenter": function($event) {
          _vm.hoverLevel1($event, index)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t")])], _vm._v(" "), (_vm.versionMob) ? _c('ul', {
      staticClass: "List_L2"
    }, _vm._l((item.submenu), function(item2, index) {
      return _c('li', [
        [(item2.submenu) ? _c('div', {
          staticClass: "wrap",
          on: {
            "click": function($event) {
              _vm.blockLink($event, index), _vm.clickShowL2($event, index)
            }
          }
        }, [_c('a', {
          staticClass: "level2Span",
          attrs: {
            "href": item2.href
          },
          on: {
            "click": function($event) {
              _vm.clickShowL2($event, index)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(item2.name) + "\n\t\t\t\t\t\t\t\t\t\t"), _c('span', {
          staticClass: "nextLevel"
        }, [_c('svg', {
          attrs: {
            "viewBox": "0 0 24 24",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('path', {
          attrs: {
            "d": "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M0-.25h24v24H0z",
            "fill": "none"
          }
        })])])])]) : _c('a', {
          attrs: {
            "href": item2.href
          },
          on: {
            "click": function($event) {
              _vm.clickShowL2($event, index)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(item2.name) + "\n\t\t\t\t\t\t\t\t")])], _vm._v(" "), (item2.submenu) ? _c('ul', _vm._l((item2.submenu), function(item3, index) {
          return _c('li', [_c('a', {
            attrs: {
              "href": item3.href
            }
          }, [_vm._v(_vm._s(item3.name))])])
        })) : _vm._e()
      ], 2)
    })) : _vm._e()], 2)
  }))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.versionMob && _vm.showL2) ? _c('div', {
    staticClass: "cols s_8"
  }, [_c('ul', _vm._l((_vm.level2), function(item, index) {
    return _c('li', {
      on: {
        "mouseenter": _vm.activeLevel1
      }
    }, [
      [(item.submenu) ? _c('a', {
        attrs: {
          "href": item.href
        },
        on: {
          "mouseenter": function($event) {
            _vm.hoverLevel2($event, index)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t"), _c('span', {
        staticClass: "nextLevel"
      }, [_c('svg', {
        attrs: {
          "viewBox": "0 0 24 24",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "d": "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M0-.25h24v24H0z",
          "fill": "none"
        }
      })])])]) : _c('a', {
        attrs: {
          "href": item.href
        },
        on: {
          "mouseenter": function($event) {
            _vm.hoverLevel2($event, index)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t")])]
    ], 2)
  }))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.versionMob && _vm.showL3) ? _c('div', {
    staticClass: "cols s_8"
  }, [_c('ul', _vm._l((_vm.level3), function(item, index) {
    return _c('li', {
      on: {
        "mouseenter": _vm.activeLevel1
      }
    }, [_c('a', {
      attrs: {
        "href": item.href
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t")])])
  }))]) : _vm._e()])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4bc8ba33"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/BigMenu.vue
// module id = 323
// module chunks = 22